var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_12)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4404 7.68335C11.8482 7.68335 11.3681 8.16342 11.3681 8.75562C11.3681 9.34782 11.8482 9.82789 12.4404 9.82789C13.0326 9.82789 13.5127 9.34782 13.5127 8.75562C13.5127 8.16342 13.0326 7.68335 12.4404 7.68335ZM9.86813 8.75562C9.86813 7.33499 11.0198 6.18335 12.4404 6.18335C13.861 6.18335 15.0127 7.33499 15.0127 8.75562C15.0127 10.1762 13.861 11.3279 12.4404 11.3279C11.0198 11.3279 9.86813 10.1762 9.86813 8.75562Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.59177 17.1851C3.01805 18.1174 0.608398 19.8778 0.608398 21.8959C0.608398 24.8882 5.90596 27.3139 12.4408 27.3139C18.9757 27.3139 24.2733 24.8882 24.2733 21.8959C24.2733 19.8798 21.8685 18.121 18.3008 17.1879C17.961 17.6256 17.6115 18.0573 17.258 18.4792C18.3653 18.7243 19.3532 19.0486 20.1831 19.4286C22.2188 20.3607 22.7733 21.3438 22.7733 21.8959C22.7733 22.448 22.2188 23.4311 20.1831 24.3632C18.2791 25.235 15.5432 25.8139 12.4408 25.8139C9.33847 25.8139 6.60261 25.235 4.69852 24.3632C2.6629 23.4311 2.1084 22.448 2.1084 21.8959C2.1084 21.3438 2.6629 20.3607 4.69852 19.4286C5.53623 19.045 6.53493 18.7182 7.655 18.4723C7.29423 18.0512 6.93785 17.6208 6.59177 17.1851Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4903 2.81763C8.51044 2.81763 5.63182 6.76296 6.02345 10.3648C6.09435 11.0169 6.39489 11.8184 6.88992 12.7195C7.37964 13.611 8.03256 14.5516 8.75579 15.4726C9.9951 17.0508 11.4104 18.5329 12.4858 19.5582C13.5211 18.5526 14.8851 17.0963 16.0913 15.5315C16.7982 14.6143 17.4417 13.6719 17.9321 12.7706C18.4268 11.8615 18.7427 11.0359 18.8363 10.3452C19.3381 6.64194 16.4789 2.81763 12.4903 2.81763ZM4.53224 10.5269C4.06084 6.19149 7.47002 1.31763 12.4903 1.31763C17.5019 1.31763 20.9305 6.06053 20.3227 10.5466C20.1944 11.4937 19.7855 12.5028 19.2497 13.4875C18.7096 14.48 18.0169 15.4903 17.2793 16.4472C15.8049 18.3601 14.1139 20.1073 12.9997 21.1384L12.4945 21.6061L11.9854 21.1426C10.8307 20.0913 9.08397 18.3193 7.57605 16.399C6.82185 15.4386 6.11703 14.428 5.57523 13.4417C5.03873 12.4651 4.63394 11.4623 4.53224 10.5269Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 27,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.3ff340620f760e55fe66da401c719086.svg";
export { ForwardRef as ReactComponent };